const dateFilter = (time, format) => {
  if (!time) {
    return ''
  }
  try {
    const date = new Date(time * 1000)
    const dateNumFun = num => (num < 10 ? `0${num}` : num)
    const [Y, M, D, h, m, s] = [
      date.getFullYear(),
      dateNumFun(date.getMonth() + 1),
      dateNumFun(date.getDate()),
      dateNumFun(date.getHours()),
      dateNumFun(date.getMinutes()),
      dateNumFun(date.getSeconds())
    ]
    return (
        `${Y}-${M}-${D}` +
        (format && format.indexOf('hh:mm:ss') > -1 ? `${h}:${m}:${s}` : '')
    )
  } catch (e) {
    return ''
  }
}
export { dateFilter }
